import { render, staticRenderFns } from "./TermsCard.vue?vue&type=template&id=603eb824&"
import script from "./TermsCard.vue?vue&type=script&lang=js&"
export * from "./TermsCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports